/**
 * Lumina placeholder pattern that the streaming markdown parser writes into the
 * message `content` whenever it strips a `◐…◑` lumina payload out for separate
 * storage. Matches `[^lumina^]` and `[^lumina-N^]` (the indexed variant used
 * when multiple lumina blocks appear in one message).
 */
export const LUMINA_PLACEHOLDER_RE: RegExp = /\[\^lumina(?:-\d+)?\^\]/g;
